<template>
  <div id="baned">
    <img src="../../assets/list/wggg(1).jpg" class="imgBlock noevents-img" />
    <a @click="to_text"><img src="../../assets/list/wggg(2).jpg" class="imgBlock noevents-img" /></a>
    <img src="../../assets/list/wggg(3).jpg" class="imgBlock noevents-img" />

    <div class="list relativeItem">
      <div class="title relativeItem">
        <span class="s1">昵称</span>
        <span class="s2">违规内容</span>
        <span class="s3">处罚</span>
        <i class="i1 absoluteItem"></i>
        <i class="i2 absoluteItem"></i>
      </div>
      <div id="u">
        <table id="u1">
          <tr class="item flex-box" v-for="(n, index) in list" :key="index">
            <td class="s1">{{ n.nickname }}</td>
            <td class="s2">{{ n.content }}</td>
            <td class="s3">{{ n.operation_type }}</td>
          </tr>
        </table>
        <table id="u2"></table>
      </div>
    </div>
    <div class="relativeItem">
      <img src="../../assets/list/wggg(5).jpg" />
    </div>
  </div>
</template>

<script>
export default {
  name: "baned",
  data() {
    return {
      list: [],
      roll_obj: null, //滚动计时器
    };
  },
  methods: {
    /**前往text页面 */
    to_text(){
      this.$router.push({path:"/banedtext"});
    },

    getList() {
      let _this = this;
      this.$jsonp(this.$apis("bandlist"), {}, (res) => {
        _this.list = res.data.data.result.list;
        _this.give_u2_data();
      });
    },

    /**给u2赋值 */
    give_u2_data() {
      let _this = this;
      setTimeout(() => {
        if (document.getElementById("u1").offsetHeight > 500) {
          document.getElementById("u2").innerHTML = document.getElementById(
            "u1"
          ).innerHTML;
          _this.roll();
        } else {
          document.getElementById("u2").innerHTML = "";
          clearInterval(_this.roll_obj);
        }
      }, 500);
    },

    /**无缝滚动 */
    roll() {
      let u = this.$tool.getByID("u"),
        u1 = this.$tool.getByID("u1");
      var height = u1.offsetHeight;
      this.roll_obj = setInterval(function () {
        if (u.scrollTop >= height) {
          u.scrollTop = 0;
        }
        u.scrollTop += 1;
      }, 50);
    },
  },
  mounted: function () {
    this.$tool.setTitle("违规公告");
    this.getList();
  },
  watch: {},
};
</script>









<style scoped>
img {
  display: block;
}
.text-href {
  display: inline-block;
  width: 100%;
  text-align: center;
  color: #8386ff;
  margin-bottom: 20px;
  text-decoration: underline;
  border: 0;
}
.list {
  background: url("../../assets/list/wggg(4).jpg") repeat left top;
  background-size: 100% 100%;
}
#u {
  height: 500px;
  overflow-y: scroll;
}
#u1,
#u2 {
  width: 85%;
  margin: 0 auto;
  border: 1px solid #4186ff;
  border-top: none;
  min-height: 500px;
  border-collapse: collapse;
  table-layout: fixed;
}
tr {
  border-bottom: 1px solid #4186ff;
  position: relative;
  align-items: center;
}
.item {
  position: relative;
}
.item::after,
.item::before {
  position: absolute;
  content: "";
  width: 1px;
  height: 100%;
  background: #4186ff;
  top: 0;
  left: 25%;
}
.item::after {
  left: 75%;
}
td {
  font-size: 11px;
  display: inline-block;
  padding: 12px 2px;
  height: 100%;
  text-align: center;
  word-wrap: break-word;
}
.title {
  height: 30px;
  width: 100%;
  padding: 0 7.5%;
}
.title span {
  display: inline-block;
  background: #b3daff;
  color: #2c72b5;
  padding: 0;
  line-height: 30px;
  font-size: 11px;
  text-align: center;
}
.title i {
  width: 1px;
  height: 100%;
  background: #4186ff;
}
.title .i1 {
  left: 29%;
}
.title .i2 {
  left: 71.3%;
}

.s1,
.s3 {
  width: 25%;
}
.s2 {
  width: 50%;
}
.s3 {
  border-right: 0 !important;
}
tr:last-child {
  border-bottom: 0;
}
</style>
